(function () {
  window.dataLayer = window.dataLayer || [];
  if (window.__zuberLegacyAddToCartFilterInstalled) return;
  window.__zuberLegacyAddToCartFilterInstalled = true;

  const nativePush = window.dataLayer.push.bind(window.dataLayer);

  function isLegacyAddToCartEvent(entry) {
    if (!entry) return false;
  
    if (entry.event === "add_to_cart") {
      // eventModel, user_data veya send_to varsa kesinlikle eski yapıdır
      if (entry.eventModel || entry.user_data || entry.send_to) {
        return true;
      }
      if (!entry.ecommerce) {
        return Boolean(
          entry.ecomm_pagetype ||
          entry.ecomm_prodid ||
          entry.ecomm_totalvalue ||
          entry.items
        );
      }
    }
  
    if (entry[0] === "event" && entry[1] === "add_to_cart") {
      const params = entry[2] || {};
      return Boolean(
        params.eventModel ||
        params.user_data ||
        (!params.ecommerce && (params.ecomm_pagetype || params.ecomm_prodid || params.items))
      );
    }
  
    return false;
  }

  function isLegacyViewItemEvent(entry) {
    if (!entry) return false;
  
    if (entry.event === "view_item") {
      if (entry.eventModel || entry.user_data) return true;
      if (!entry.ecommerce) {
        return Boolean(entry.ecomm_pagetype || entry.ecomm_prodid || entry.ecomm_totalvalue);
      }
    }
  
    if (entry[0] === "event" && entry[1] === "view_item") {
      const params = entry[2] || {};
      return Boolean(params.eventModel || (!params.ecommerce && (params.ecomm_pagetype || params.ecomm_prodid)));
    }
  
    return false;
  }

  // Geçmişe dönük temizlik: Bu script yüklenmeden ÖNCE dataLayer'a atılmış legacy event'leri array'den siler
  for (let i = window.dataLayer.length - 1; i >= 0; i--) {
    if (isLegacyAddToCartEvent(window.dataLayer[i]) || isLegacyViewItemEvent(window.dataLayer[i])) {
      window.dataLayer.splice(i, 1);
    }
  }

  // Yeni gelecek push'ları filtreleyen override
  window.dataLayer.push = function (...entries) {
    const filteredEntries = entries.filter((entry) => 
      !isLegacyAddToCartEvent(entry) && !isLegacyViewItemEvent(entry)
    );
    if (!filteredEntries.length) return window.dataLayer.length;
    return nativePush(...filteredEntries);
  };
})();

document.addEventListener("DOMContentLoaded", function () {

  // ============================================================
  // GLOBAL VARIABLES
  // Buffer for batching view_item_list events (sends every 4 products)
  // ============================================================
  let viewedProductsBuffer = [];

  // ============================================================
  // HELPER: Generates a unique event ID for each dataLayer push
  // ============================================================
  function generateEventId() {
    return "evt_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
  }

  // ============================================================
  // HELPER: Rounds a number to 2 decimal places for price formatting
  // ============================================================
  function formatPrice(value) {
    const num = Number(value);
    return isNaN(num) ? 0 : parseFloat(num.toFixed(2));
  }

  // ============================================================
  // HELPER: SHA-256 hashes a string value (used for PII like email, phone)
  // ============================================================
  async function hashData(value) {
    if (!value) return null;
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(value.toString().trim().toLowerCase());
    const hash = await crypto.subtle.digest("SHA-256", dataBuffer);
    return Array.from(new Uint8Array(hash)).map(b => b.toString(16).padStart(2, "0")).join("");
  }

  // ============================================================
  // HELPER: Reads customer data from window.__customer
  // window.__customer is set in theme.liquid HEAD section
  // ============================================================
  function getCustomerData() {
    const c = window.__customer || {};
    const defaultAddress = c.default_address || c.defaultAddress || {};
    const firstAddress = Array.isArray(c.addresses) ? (c.addresses[0] || {}) : {};
    return {
      id: c.id || null,
      email: c.email || null,
      phone: c.phone || defaultAddress.phone || firstAddress.phone || null,
      firstName: c.firstName || c.first_name || defaultAddress.first_name || firstAddress.first_name || null,
      lastName: c.lastName || c.last_name || defaultAddress.last_name || firstAddress.last_name || null
    };
  }

  // ============================================================
  // HELPER: Pushes otherEventData to dataLayer
  // NOTE: This is a fallback. otherEventData is primarily sent
  // from theme.liquid HEAD via an inline async script.
  // If window.__otherEventDataSent is already true, this is skipped.
  // ============================================================
  async function pushOtherEventDataEarly() {
    if (window.__otherEventDataSent) return;
    const c = getCustomerData();
    const [hashed_email, hashed_phone, hashed_firstname, hashed_lastname] = await Promise.all([
      hashData(c.email), hashData(c.phone), hashData(c.firstName), hashData(c.lastName)
    ]);
    const hasAnyData = c.id || hashed_email || hashed_phone || hashed_firstname || hashed_lastname;
    if (!hasAnyData) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "otherEventData", crm_id: c.id || null, hashed_email, hashed_phone, hashed_firstname, hashed_lastname });
    window.__otherEventDataSent = true;
    /* console.log("👤 [otherEventData] Sent | crm_id:", c.id || "null"); */
  }

  // ============================================================
  // HELPER: Dynamically reads item_category through item_category{n}
  // from data attributes on a given element.
  // - el: the element to read from (button or row)
  // - prefix: "data-product" for product cards, "data-item" for cart rows
  // - maxN: maximum number of categories to read (usually 5)
  // Missing or empty attributes safely return "" without throwing errors.
  // ============================================================
  function buildCategories(el, prefix, maxN) {
    const result = {};
    for (let n = 1; n <= maxN; n++) {
      const key  = n === 1 ? "item_category"  : `item_category${n}`;
      const attr = n === 1 ? `${prefix}-category` : `${prefix}-category${n}`;
      result[key] = el?.getAttribute(attr) || "";
    }
    return result;
  }

  // ============================================================
  // HELPER: Reads base item data from a cart row element.
  // btn takes priority over row for attribute reading.
  // Categories are built dynamically via buildCategories() to avoid
  // hard-coded attribute access errors when values are missing.
  // ============================================================
  function getItemDataFromRow(row, btn) {
    const el = btn || row;
    return {
      item_id:        el?.getAttribute("data-item-id")     || row?.getAttribute("data-item-id")     || "",
      item_name:      el?.getAttribute("data-item-name")   || row?.getAttribute("data-item-name")   || "",
      affiliation:    "Zuber",
      coupon:         el?.getAttribute("data-item-coupon") || row?.getAttribute("data-item-coupon") || "",
      index:          Number(el?.getAttribute("data-item-index")) || Number(row?.getAttribute("data-line")) || 1,
      item_brand:     el?.getAttribute("data-item-brand")  || row?.getAttribute("data-item-brand")  || "Zuber",
      ...buildCategories(el || row, "data-item", 5),
      item_list_id:   row?.getAttribute("data-item-list-id") || "",
      item_list_name: "Cart"
    };
  }

  let pendingAddToCartContext = null;
  let lastAddToCartSignature = "";

  function findAddToCartContextElement(el) {
    const form = el?.closest?.('form[action*="/cart/add"], form[data-product-form]');
    const variantId =
      el?.getAttribute("data-product-id") ||
      form?.querySelector?.('[name="id"]')?.value ||
      "";
  
    return (
      el?.closest?.(".js-datalayer-product, [data-view-item], .product-item, .product") ||
      document.querySelector(`.js-datalayer-product[data-product-variant-id="${CSS.escape(variantId)}"]`) ||
      document.querySelector(`.js-datalayer-product[data-variant-id="${CSS.escape(variantId)}"]`)
    );
  }

  function getProductContextFromElement(el) {
    if (!el) return {};
    const originalPrice = formatPrice(el.getAttribute("data-product-original-price") || el.getAttribute("data-product-price"));
    const salePrice = formatPrice(el.getAttribute("data-product-price"));
    const discount = formatPrice(
        el.getAttribute("data-product-discount") || Math.max(0, originalPrice - salePrice)
    );

    return {
      item_id: el.getAttribute("data-product-id") || "",
      item_name: el.getAttribute("data-product-name") || "",
      item_brand: el.getAttribute("data-product-brand") || "Zuber",
      item_variant: el.getAttribute("data-product-variant") || "Default Title",
      ...buildCategories(el, "data-product", 5),
      item_list_id: el.getAttribute("data-product-list-id") || "related_products",
      item_list_name: el.getAttribute("data-product-list-name") || "Related Products",
      price: originalPrice,
      discount: discount,
      quantity: Number(el.querySelector?.('[name="quantity"]')?.value) || 1,
      index: Number(el.getAttribute("data-product-index")) || 0
    };
  }

  function capturePendingAddToCart(btn) {
    const productEl = findAddToCartContextElement(btn);
    const form = btn?.closest?.('form[action*="/cart/add"], form[data-product-form]');
    pendingAddToCartContext = {
      createdAt: Date.now(),
      variantId: form?.querySelector?.('[name="id"]')?.value || btn?.getAttribute("data-product-id") || "",
      ...getProductContextFromElement(productEl)
    };
  }

  function buildAddToCartPayloadFromCartItem(item, context) {
    const cartSalePrice = formatPrice(
      (item.final_price || item.discounted_price || item.price || 0) / 100
    );
  
    const originalPrice = formatPrice(
      context?.price ||
      context?.original_price ||
      context?.originalPrice ||
      (item.original_price && item.original_price > item.price ? item.original_price : item.price) / 100 ||
      cartSalePrice
    );
  
    const finalPrice = formatPrice(
      context?.sale_price ||
      context?.salePrice ||
      cartSalePrice
    );
  
    const quantity = Number(context?.quantity || item.quantity) || 1;
  
    const discount = formatPrice(
      context?.discount ||
      Math.max(0, originalPrice - finalPrice)
    );
  
    const categories = {
      item_category: context?.item_category || item.product_type || "",
      item_category2: context?.item_category2 || "",
      item_category3: context?.item_category3 || "",
      item_category4: context?.item_category4 || "",
      item_category5: context?.item_category5 || ""
    };
  
    return {
      event: "add_to_cart",
      timestamp: Date.now(),
      id: generateEventId(),
      url: window.location.href,
      ecommerce: {
        currency: window.Shopify?.currency?.active || "TRY",
        value: formatPrice(finalPrice * quantity),
        items: [{
          item_id: item.sku || context?.item_id || String(item.product_id || item.variant_id || context?.variantId || ""),
          item_name: item.product_title || context?.item_name || item.title || "",
          item_brand: item.vendor || context?.item_brand || "Zuber",
          item_variant: item.variant_title || context?.item_variant || "Default Title",
          ...categories,
          item_list_id: context?.item_list_id || "related_products",
          item_list_name: context?.item_list_name || "Related Products",
          affiliation: "Züber",
  
          price: originalPrice,
          discount: discount > 0 ? discount : 0,
          quantity: quantity,
  
          google_business_vertical: "retail",
          index: Number(context?.index) || 0
        }]
      }
    };
  }

  function buildAddToCartPayloadFromPixelEvent(event) {
    const line = event?.data?.cartLine;
    const variant = line?.merchandise;
    const product = variant?.product;
  
    const context = pendingAddToCartContext || {};
  
    const pixelSalePrice = formatPrice(
      variant?.price?.amount ||
      line?.cost?.amountPerQuantity?.amount ||
      line?.cost?.totalAmount?.amount ||
      0
    );
  
    const originalPrice = formatPrice(
      context?.price ||
      variant?.compareAtPrice?.amount ||
      pixelSalePrice
    );
  
    const finalPrice = formatPrice(
      context?.sale_price ||
      variant?.price?.amount ||
      pixelSalePrice
    );
  
    const quantity = Number(context?.quantity || line?.quantity) || 1;
  
    const discount = formatPrice(
      context?.discount ||
      Math.max(0, originalPrice - finalPrice)
    );
  
    return {
      event: "add_to_cart",
      timestamp: event?.timestamp || Date.now(),
      id: event?.id || generateEventId(),
      url: event?.context?.document?.location?.href || window.location.href,
      ecommerce: {
        currency: line?.cost?.totalAmount?.currencyCode || window.Shopify?.currency?.active || "TRY",
        value: formatPrice(finalPrice * quantity),
        items: [{
          item_id: context?.item_id || variant?.sku || variant?.id || "",
          item_name: context?.item_name || product?.title || variant?.title || "",
          item_brand: context?.item_brand || product?.vendor || "Zuber",
          item_variant: context?.item_variant || variant?.title || "Default Title",
  
          item_category: context?.item_category || product?.type || "",
          item_category2: context?.item_category2 || "",
          item_category3: context?.item_category3 || "",
          item_category4: context?.item_category4 || "",
          item_category5: context?.item_category5 || "",
  
          item_list_id: context?.item_list_id || "related_products",
          item_list_name: context?.item_list_name || "Related Products",
          affiliation: "Züber",
  
          price: originalPrice,
          discount: discount > 0 ? discount : 0,
          quantity: quantity,
  
          google_business_vertical: "retail",
          index: Number(context?.index) || 0
        }]
      }
    };
  }

  function pushAddToCartPayload(payload) {
    if (!payload?.ecommerce?.items?.length) return;
    const item = payload.ecommerce.items[0];
    const signature = [
      payload.event,
      item.item_id,
      item.quantity
    ].join("|");
    
    if (signature === lastAddToCartSignature) return;
    lastAddToCartSignature = signature;
    
    // 3 saniye sonra signature'ı sıfırla (aynı ürünü tekrar ekleyebilsin)
    setTimeout(() => {
      if (lastAddToCartSignature === signature) lastAddToCartSignature = "";
    }, 3000);
  
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    pendingAddToCartContext = null;
  }
  function isCartAddRequest(input) {
    const url = typeof input === "string" ? input : input?.url;
    if (!url) return false;
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  function pushAddToCartFromAddResponse(data) {
    if (!data || data.status === 422) return;
    const item = Array.isArray(data.items) ? data.items[0] : data;
    if (!item) return;
    pushAddToCartPayload(buildAddToCartPayloadFromCartItem(item, pendingAddToCartContext));
  }

  function installAddToCartFetchTracker() {
    if (window.__zuberAddToCartFetchTrackerInstalled || typeof window.fetch !== "function") return;
    window.__zuberAddToCartFetchTrackerInstalled = true;
    const nativeFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      const isAddRequest = isCartAddRequest(input);
      return nativeFetch(input, init).then((response) => {
        if (isAddRequest && response.ok) {
          response.clone().json()
              .then(pushAddToCartFromAddResponse)
              .catch(() => {});
        }
        return response;
      });
    };
  }

  function pushPendingAddToCartFromCart() {
    if (!pendingAddToCartContext || Date.now() - pendingAddToCartContext.createdAt > 5000) return;

    fetch((window.theme?.routes?.cart?.base || "/cart") + ".js", { credentials: "include" })
        .then((res) => res.ok ? res.json() : Promise.reject(res))
        .then((cart) => {
          const item = cart.items?.find((cartItem) => {
            return String(cartItem.variant_id) === String(pendingAddToCartContext.variantId) ||
                String(cartItem.id) === String(pendingAddToCartContext.variantId) ||
                (pendingAddToCartContext.item_id && String(cartItem.sku || cartItem.product_id) === String(pendingAddToCartContext.item_id));
          }) || cart.items?.[0];
          if (!item) return;
          pushAddToCartPayload(buildAddToCartPayloadFromCartItem(item, pendingAddToCartContext));
        })
        .catch((err) => console.error("❌ [add_to_cart] cart lookup failed", err));
  }

  // ============================================================
  // MAIN TRACKING FUNCTION
  // Called on DOMContentLoaded and on every DOM mutation.
  // Uses gtm-loaded class to prevent duplicate event bindings.
  // ============================================================
  function initTracking() {

    // ----------------------------------------------------------
    // PART 1: SLIDER / BANNER TRACKING (view_promotion + select_promotion)
    // - Skipped on cart page
    // - IntersectionObserver fires view_promotion when slide enters viewport
    // - MutationObserver watches for inert attribute removal (slide change)
    // - Click fires select_promotion and navigates after 300ms delay
    // ----------------------------------------------------------
    const isCartPage = window.location.pathname.includes("/cart");

    if (!isCartPage) {

      // Reads promotion data attributes from a slide element
      function getSlidePromoData(slide) {
        return {
          creative_name:  slide.getAttribute("data-creative-name")  || slide.getAttribute("data-promotion-name") || null,
          creative_slot:  slide.getAttribute("data-creative-slot")  || null,
          promotion_id:   slide.getAttribute("data-promotion-id")   || null,
          promotion_name: slide.getAttribute("data-promotion-name") || null
        };
      }

      // Clears ecommerce object then pushes promotion event to dataLayer
      function pushPromoEvent(eventName, promoData) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({ event: eventName, timestamp: Date.now(), id: generateEventId(), url: window.location.href, ecommerce: promoData });
      }

      // Fires view_promotion once per slide (uses dataset.promoViewed flag)
      // Skips slides that have the inert attribute (not visible/active)
      function fireViewPromotion(slide) {
        if (slide.dataset.promoViewed === "true") return;
        if (slide.hasAttribute("inert")) return;
        slide.dataset.promoViewed = "true";
        const promoData = getSlidePromoData(slide);
        pushPromoEvent("view_promotion", promoData);
        /*  console.log("🎯 [view_promotion] slot:", promoData.creative_slot, "| name:", promoData.promotion_name); */
      }

      // Checks if element is currently visible in the browser viewport
      function isInViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0;
      }

      // IntersectionObserver: fires view_promotion when slide is 50% visible
      const promotionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          fireViewPromotion(entry.target);
        });
      }, { root: null, threshold: 0.5 });

      // Binds view + click tracking to a slide element (once per slide)
      function bindSlide(slide) {
        if (slide.dataset.gtmBound === "true") return;
        slide.dataset.gtmBound = "true";
        if (!slide.hasAttribute("inert")) promotionObserver.observe(slide);
        slide.addEventListener("click", function (e) {
          const link =
              this.querySelector(".slideshow-slide__image-link") ||
              this.querySelector(".slideshow-slide__text-container-image-button a") ||
              this.querySelector("a[href]");
          const url      = link ? link.href : null;
          const isNewTab = (link && link.target === "_blank") || e.ctrlKey || e.metaKey || e.shiftKey;
          const promoData = getSlidePromoData(this);
          pushPromoEvent("select_promotion", promoData);
          /* console.log("🖱️ [select_promotion] slot:", promoData.creative_slot, "| name:", promoData.promotion_name); */
          // Delay navigation to allow GA4 hit to fire before page unload
          if (url && !isNewTab) {
            e.preventDefault();
            setTimeout(() => { window.location.href = url; }, 300);
          }
        });
      }

      // Bind all existing slides on page load
      document.querySelectorAll(".js-slider-item").forEach(bindSlide);

      // MutationObserver: re-binds and fires view_promotion when slider changes active slide
      const sliderContainer = document.querySelector(".slideshow__inner");
      if (sliderContainer) {
        const inertObserver = new MutationObserver(() => {
          document.querySelectorAll(".js-slider-item:not([inert])").forEach(slide => {
            if (slide.dataset.gtmBound !== "true") bindSlide(slide);
            if (slide.dataset.promoViewed !== "true") {
              promotionObserver.observe(slide);
              if (isInViewport(slide)) fireViewPromotion(slide);
            }
          });
        });
        inertObserver.observe(sliderContainer, { subtree: true, attributes: true, attributeFilter: ["inert"] });
      }
    }

    // ----------------------------------------------------------
    // PART 2: PRODUCT LIST TRACKING (view_item_list + select_item)
    // - IntersectionObserver fires when product card enters viewport
    // - Products are buffered and sent in batches of 4
    // - Categories read dynamically via buildCategories()
    // - Click fires select_item and stores list info in sessionStorage
    // ----------------------------------------------------------
    const products = document.querySelectorAll(".js-datalayer-product:not(.gtm-loaded)");

    if (products.length > 0) {

      // Fires view_item_list in batches of 4 as products enter viewport
      const productObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const product = entry.target;
          const originalPrice = formatPrice(product.getAttribute("data-product-original-price") || product.getAttribute("data-product-price"));

          const data = {
            item_id:        product.getAttribute("data-product-id"),
            item_name:      product.getAttribute("data-product-name"),
            affiliation:    "Zuber",
            coupon:         product.getAttribute("data-product-coupon") || "",
            index:          Number(product.getAttribute("data-product-index")) || 1,
            item_brand:     product.getAttribute("data-product-brand") || "Zuber",
            ...buildCategories(product, "data-product", 5),
            item_list_id:   product.getAttribute("data-product-list-id") || "",
            item_list_name: product.getAttribute("data-product-list-name") || "",
            item_variant:   product.getAttribute("data-product-variant") || "Default Title",
            price:          originalPrice,
            discount:       parseFloat(product.getAttribute("data-product-discount")) || 0.0,
            quantity:       1
          };

          viewedProductsBuffer.push(data);
          observer.unobserve(product);

          // Send batch when 4 products have been viewed
          if (viewedProductsBuffer.length >= 4) {
            const batch = viewedProductsBuffer.splice(0, 4);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({ event: "view_item_list", timestamp: Date.now(), id: generateEventId(), url: window.location.href, ecommerce: { items: batch } });
            /* console.log("📤 [view_item_list] Sent:", batch.map(i => i.item_name).join(", ")); */
          }
        });
      }, { root: null, threshold: 0.2 });

      products.forEach(product => {
        product.classList.add("gtm-loaded"); // Prevents re-binding on DOM mutations
        productObserver.observe(product);

        // select_item fires on product card click, stores list context for view_item
        product.addEventListener("click", function () {
          const originalPrice = formatPrice(this.getAttribute("data-product-original-price") || this.getAttribute("data-product-price"));

          const data = {
            item_id:        this.getAttribute("data-product-id"),
            item_name:      this.getAttribute("data-product-name"),
            affiliation:    "Zuber",
            coupon:         this.getAttribute("data-product-coupon") || "",
            index:          Number(this.getAttribute("data-product-index")) || 1,
            item_brand:     this.getAttribute("data-product-brand") || "Zuber",
            ...buildCategories(this, "data-product", 5),
            item_list_id:   this.getAttribute("data-product-list-id") || "",
            item_list_name: this.getAttribute("data-product-list-name") || "",
            item_variant:   this.getAttribute("data-product-variant") || "Default Title",
            price:          originalPrice,
            discount:       parseFloat(this.getAttribute("data-product-discount")) || 0.0,
            quantity:       1
          };

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({ event: "select_item", timestamp: Date.now(), id: generateEventId(), url: window.location.href, ecommerce: { items: [data] } });

          // Store list context so view_item page can reference which list the user came from
          sessionStorage.setItem("last_list_id", data.item_list_id);
          sessionStorage.setItem("last_list_name", data.item_list_name);
          /* console.log("👆 [select_item]", data.item_name, "| index:", data.index); */
        });
      });
    }

    // ----------------------------------------------------------
    // PART 3: REMOVE FROM CART — Remove button (.js-remove-item)
    // - Fires when user clicks the "Remove" text button on cart page
    // - Reads all item data from data attributes on the button and row
    // - Uses final_line_price for value if available, otherwise calculates
    // ----------------------------------------------------------
    const removeButtons = document.querySelectorAll(".js-remove-item:not(.gtm-loaded)");
    removeButtons.forEach(btn => {
      btn.classList.add("gtm-loaded");
      btn.addEventListener("click", function () {
        const row = this.closest(".cart__form-item");
        if (!row) return;

        const qty            = Number(this.getAttribute("data-item-quantity") || row.getAttribute("data-item-quantity") || 1) || 1;
        const originalPrice  = formatPrice(this.getAttribute("data-item-original-price") || row.getAttribute("data-item-original-price") || 0);
        const salePrice      = formatPrice(this.getAttribute("data-item-price") || row.getAttribute(",") || 0);
        const finalLinePrice = parseFloat(this.getAttribute("data-item-final-price") || row.getAttribute("data-item-final-price") || 0) || 0;
        const discount       = parseFloat(this.getAttribute("data-item-discount") || row.getAttribute("data-item-discount") || Math.max(0, originalPrice - salePrice)) || 0.0;
        // Use final_line_price if available, otherwise calculate from unit sale price × qty
        const value         = parseFloat((salePrice * qty).toFixed(2)); // value = 1 unit sale price

        let itemVariant = (this.getAttribute("data-item-variant") || row.getAttribute("data-item-variant") || "Default Title").trim();

        const itemData = {
          ...getItemDataFromRow(row, this),
          item_variant: itemVariant,
          price:        originalPrice,
          discount:     discount,
          quantity:     qty
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "remove_from_cart", timestamp: Date.now(), id: generateEventId(), url: window.location.href,
          ecommerce: { currency: window.Shopify?.currency?.active || "TRY", value, items: [itemData] }
        });
        /*  console.log("🗑️ [remove_from_cart]", itemData.item_name, "| qty:", qty, "| value:", value); */
      });
    });

  } // End of initTracking

  // ----------------------------------------------------------
  // PART 3b: REMOVE FROM CART — Minus button (.product__quantity-subtract-item)
  // - Uses event delegation so it works even after AJAX DOM updates
  // - Fires on every click regardless of current quantity
  // - Always sends quantity: 1 (each click = 1 unit removed)
  // ----------------------------------------------------------
  document.addEventListener("click", function(e) {
    const btn = e.target.closest(".product__quantity-subtract-item");
    if (!btn) return;

    const row = btn.closest(".cart__form-item");
    if (!row) return;

    const originalPrice = formatPrice(row.getAttribute("data-item-original-price") || 0);
    const salePrice     = formatPrice(row.getAttribute("data-item-price") || 0);
    const discount      = parseFloat(row.getAttribute("data-item-discount") || Math.max(0, originalPrice - salePrice)) || 0.0;
    const value         = parseFloat((salePrice * 1).toFixed(2)); // value = 1 unit sale price

    let itemVariant = (row.getAttribute("data-item-variant") || "Default Title").trim();

    const itemData = {
      ...getItemDataFromRow(row, null),
      item_variant: itemVariant,
      price:        originalPrice,
      discount:     discount,
      quantity:     1 // Each minus click removes 1 unit
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "remove_from_cart", timestamp: Date.now(), id: generateEventId(), url: window.location.href,
      ecommerce: { currency: window.Shopify?.currency?.active || "TRY", value, items: [itemData] }
    });
    /* console.log("🗑️ [remove_from_cart] minus btn", itemData.item_name, "| value:", value); */
  });

  // ----------------------------------------------------------
// PART 3c: ADD TO CART — Plus button on cart page
// - Cart page quantity increase = add_to_cart event
// - Uses /cart/update.js (not /cart/add.js), so fetch tracker misses it
// - Event delegation, reads context from cart row data attributes
// ----------------------------------------------------------
  document.addEventListener("click", function(e) {
    const btn = e.target.closest(".product__quantity-add-item");
    if (!btn) return;

    const row = btn.closest(".cart__form-item");
    if (!row) return;

    // Sepet sayfasında mıyız?
    if (!window.location.pathname.includes("/cart")) return;

    const originalPrice = formatPrice(row.getAttribute("data-item-original-price") || 0);
    const salePrice     = formatPrice(row.getAttribute("data-item-price") || 0);
    const discount      = parseFloat(row.getAttribute("data-item-discount") || Math.max(0, originalPrice - salePrice)) || 0.0;
    const value         = parseFloat((salePrice * 1).toFixed(2));

    let itemVariant = (row.getAttribute("data-item-variant") || "Default Title").trim();

    const itemData = {
      ...getItemDataFromRow(row, null),
      item_variant: itemVariant,
      price:        originalPrice,
      discount:     discount,
      quantity:     1
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "add_to_cart",
      timestamp: Date.now(),
      id: generateEventId(),
      url: window.location.href,
      ecommerce: {
        currency: window.Shopify?.currency?.active || "TRY",
        value: value,
        items: [itemData]
      }
    });
    /* console.log("➕ [add_to_cart] plus btn", itemData.item_name, "| value:", value); */
  });

  // ----------------------------------------------------------
  // PART 4: VIEW CART
  // - Fires only on /cart page
  // - Fetches live cart data from /cart.js
  // - Reads compare_at_price from data attributes on cart row elements
  // - Falls back to /cart.js price data if row element not found
  // - Categories read dynamically via buildCategories()
  // ----------------------------------------------------------
  function handleViewCart() {
    if (!window.location.pathname.includes("/cart")) return;
    fetch("/cart.js")
        .then(r => r.json())
        .then(cart => {
          const cartItems = cart.items.map((item, index) => {
            // Try to find the matching DOM row for this cart item
            const row =
                document.querySelector(`[data-item-key="${CSS.escape(item.key)}"]`) ||
                document.querySelector(`[data-key="${CSS.escape(item.key)}"]`) ||
                document.querySelector(`[data-id="${item.id}"]`);

            const qty            = Number(item.quantity) || 1;
            const compareAtPrice = formatPrice((item.variant?.compare_at_price || 0) / 100);
            const salePrice      = formatPrice((item.price || 0) / 100);

            // Use data attribute if row found, otherwise fall back to /cart.js compare_at_price
            const originalUnitPrice = row
                ? formatPrice(row.getAttribute("data-item-original-price"))
                : (compareAtPrice > 0 ? compareAtPrice : salePrice);

            const finalUnitPrice = row
                ? formatPrice(row.getAttribute("data-item-price"))
                : salePrice;

            const discount = formatPrice(Math.max(0, originalUnitPrice - finalUnitPrice));

            let itemVariant = row?.getAttribute("data-item-variant") || item.variant_title || "Default Title";

            // First category falls back to item.product_type if row attribute is empty
            const categories = buildCategories(row, "data-item", 5);
            if (!categories.item_category && item.product_type) {
              categories.item_category = item.product_type;
            }

            return {
              item_id:        item.sku || String(item.product_id),
              item_name:      row?.getAttribute("data-item-name") || item.product_title,
              affiliation:    "Zuber",
              coupon:         item.discounts?.[0]?.title || "",
              index:          index + 1,
              item_brand:     row?.getAttribute("data-item-brand") || item.vendor || "Zuber",
              ...categories,
              item_list_id:   row?.getAttribute("data-item-list-id") || "",
              item_list_name: row?.getAttribute("data-item-list-name") || "Cart",
              item_variant:   itemVariant,
              price:          originalUnitPrice,
              discount:       discount,
              quantity:       qty
            };
          });

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: "view_cart", timestamp: Date.now(), id: generateEventId(), url: window.location.href,
            ecommerce: { currency: cart.currency, value: formatPrice(cart.total_price / 100), items: cartItems }
          });
          /*  console.log("🛒 [view_cart] Sent | total:", formatPrice(cart.total_price / 100), cart.currency, "| items:", cartItems.length); */
        })
        .catch(err => console.error("❌ [view_cart]", err));
  }

  // ----------------------------------------------------------
  // PART 5: VIEW ITEM
  // - Fires only on /products/ pages
  // - Reads product data from data attributes on the product element
  // - Categories read dynamically via buildCategories()
  // - Reads list context from sessionStorage (set by select_item click)
  // - Falls back to document.referrer for list context if sessionStorage is empty
  // - window.__viewItemSent flag prevents duplicate firing
  // ----------------------------------------------------------
  function handleViewItem() {
    if (!window.location.pathname.includes("/products/")) return;
    let productEl =
        document.querySelector("[data-view-item]") ||
        document.querySelector(".js-datalayer-product") ||
        document.querySelector("[data-product-id]") ||
        document.querySelector(".product-item") ||
        document.querySelector(".product");
    if (!productEl) { console.warn("⚠️ [view_item] Product element not found"); return; }

    const originalPrice = parseFloat(productEl.getAttribute("data-product-original-price") || productEl.getAttribute("data-product-price") || 0) || 0;
    const salePrice     = parseFloat(productEl.getAttribute("data-product-price") || 0) || 0;
    const discount      = parseFloat(productEl.getAttribute("data-product-discount")) || Math.max(0, Number((originalPrice - salePrice).toFixed(2)));
    const itemId        = productEl.getAttribute("data-product-id") || document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value || null;
    const itemName      = productEl.getAttribute("data-product-name") || document.querySelector("h1.product__title, h1")?.textContent?.trim() || null;
    const itemBrand     = productEl.getAttribute("data-product-brand") || "Zuber";

    let itemVariant = (productEl.getAttribute("data-product-variant") || "Default Title").trim();

    // Read list context from sessionStorage (populated by select_item click)
    let itemListId   = sessionStorage.getItem("last_list_id")   || "";
    let itemListName = sessionStorage.getItem("last_list_name") || "";
    // Fallback: derive list context from document.referrer if coming from a collection page
    if (!itemListId && document.referrer.includes("/collections/")) {
      const handle = document.referrer.split("/collections/")[1].split(/[/?#]/)[0];
      itemListId   = handle;
      itemListName = handle.replace(/-/g, " ");
    }

    if (window.__viewItemSent) return; // Prevent duplicate firing

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "view_item", timestamp: Date.now(), id: generateEventId(), url: window.location.href,
      ecommerce: {
        currency: window.Shopify?.currency?.active || "TRY",
        value:    salePrice,
        items: [{
          item_id:        itemId,
          item_name:      itemName,
          affiliation:    "Zuber",
          coupon:         productEl.getAttribute("data-product-coupon") || "",
          index:          1,
          item_brand:     itemBrand,
          ...buildCategories(productEl, "data-product", 5),
          item_list_id:   itemListId || "data-product-list-id",
          item_list_name: itemListName || "data-product-list-name",
          item_variant:   itemVariant,
          price:          originalPrice,
          discount:       discount,
          quantity:       1
        }]
      }
    });
    window.__viewItemSent = true;
    /* console.log("🔍 [view_item]", itemName, "| price:", salePrice, "| discount:", discount, "| list:", itemListName || "none"); */
  }

  // ============================================================
  // TRIGGERS
  // otherEventData is sent first from theme.liquid HEAD.
  // pushOtherEventDataEarly is a fallback in case it was missed.
  // initTracking, handleViewCart and handleViewItem run after.
  // bodyObserver re-runs initTracking on any DOM changes (AJAX pages).
  // ============================================================
  installAddToCartFetchTracker();

  pushOtherEventDataEarly().finally(() => {
    initTracking();
    handleViewCart();
    handleViewItem();
  });

  // Re-run initTracking whenever new DOM nodes are added (e.g. AJAX cart updates)
  const bodyObserver = new MutationObserver(function (mutations) {
    const hasNewNodes = mutations.some(m => m.addedNodes.length > 0);
    if (hasNewNodes) initTracking();
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener("click", function (e) {
    const btn = e.target.closest('[data-add-to-cart], [data-quick-shop-trigger="quick-add"], form[action*="/cart/add"] button[type="submit"]');
    if (!btn) return;
    capturePendingAddToCart(btn);
  }, true);

  document.addEventListener("cart:item-added", function (evt) {
   /*  const product = evt?.detail?.product;
    if (!product) {
      pushPendingAddToCartFromCart();
      return;
    }
    pushAddToCartPayload(buildAddToCartPayloadFromCartItem(product, pendingAddToCartContext)); */
  });

 /*  document.addEventListener("quick-cart:updated", pushPendingAddToCartFromCart);
  document.addEventListener("apps:product-added-to-cart", pushPendingAddToCartFromCart); */



  // ── GTM INIT ──────────────────────────────────────────────

  /* (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-PDPRL97'); */

  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

  if (!window.analytics?.subscribe) return;
});
